// const Login = () => import("./../views/Login.vue");
const LoginDirect = () => import("./../views/LoginDirect.vue");
const Recover = () => import("./../views/Recover.vue");
const RecoverPassword = () => import("./../views/RecoverPassword.vue");
const ResetPassword = () => import("./../views/ResetPassword.vue");
const VerifyTwoFactorCode = () => import("./../views/VerifyTwoFactorCode.vue");
const Unsubscribe = () => import("./../views/Unsubscribe.vue");

export default [
  { path: "/login", component: LoginDirect },
  { path: "/unsubscribe", component: Unsubscribe },
  {
    path: "/recover/",
    component: Recover,
  },
  {
    path: "/recover_password/",
    component: RecoverPassword,
  },
  {
    path: "/reset-password/",
    component: ResetPassword,
  },
  {
    path: "/verify-two-factory-code/",
    component: VerifyTwoFactorCode,
  },
];
